export enum ECommonActionTypes {
  SET_CURRENT_STEP = "SET_CURRENT_STEP"
}
